






































































































import {Vue, Component, Watch} from 'vue-property-decorator';
import PageTitle from '@/components/common/PageTitle.vue';
import MallTab from '@/components/common/MallTab.vue';
import ItemTable from '@/components/common/ItemTable.vue';
import SmsTab from '@/components/manage/sms/SmsTab.vue';
import PeriodDateCalendar from '@/components/common/datepicker/PeriodDateCalendar.vue';
import MallsTab from '@/components/common/MallsTab.vue';
import {getToday, addDay} from '@/utils/dateUtils';
import CompRadioButton from '@/components/common/CompRadioButton.vue';
import {ncpPopup} from '@/utils/ncp';
import {i18nInObjectList} from '@/utils/i18n';
import TuiGrid from 'tui-grid';
import {GetSmsMessagesRequest, SmsMessages, Mall} from 'supporter';
import {State, namespace} from 'vuex-class';
import {escapeHtml} from '@/utils/commonUtils';

const mallModule = namespace('mall');
@Component({
  components: {
    PageTitle,
    MallTab,
    ItemTable,
    SmsTab,
    PeriodDateCalendar,
    CompRadioButton,
    MallsTab
  }
})
export default class SmsSendList extends Vue {
  // data
  @mallModule.Action('fetchMalls') fetchMalls!: () => Promise<any>;
  @State('malls', {namespace: 'mall'})
  private malls!: Mall[];
  private messages: SmsMessages[] = [];
  private totalCount: number = 0;
  private pageSize: number = 100;
  private page: number = 1;
  private startDate: string = addDay(new Date(), -7);
  private endDate: string = getToday();
  private isClickView: boolean = false;
  private contentDetail = '';
  private isSms: boolean = true;
  private mallNo: number = 1;

  private periodOption = {
    name: 'periodOption',
    periodTypes: ['td', 'ytd', '3d', '1w', '1m'],
    period: '1w'
  };
  private getSmsMessagesRequest: GetSmsMessagesRequest = {
    params: {
      mallNo: Number(this.$route.query.mallNo),
      startDate: '',
      endDate: '',
      messageType: 'SMS',
      page: 1,
      pageSize: 100
    }
  };
  private messageTypeOptions = {
    name: 'messageType',
    data: [
      {
        id: 'messageType_sms',
        value: 'SMS',
        dispaly: 'SMS'
      },
      {
        id: 'messageType_lms',
        value: 'LMS',
        dispaly: 'LMS'
      }
    ]
  };
  private settingInfo = {};
  private gridProps = {
    columns: [
      {
        header: 'MANAGE_SMSSENDLIST_REQUEST__ID',
        name: 'requestId',
        align: 'center',
        minWidth: 100,
        formatter(cell: any) {
          return `<span class="requestDetail" data-request-id="${cell.value}" data-sms-type="${cell.row.messageType}" data-send-type="${window.$t('MANAGE_SMSSENDLIST_SEND')}" data-mt-pr="${
            cell.row.seq
          }">${cell.value}</span>`;
        },
      },
      {
        header: 'MANAGE_SMSSENDLIST_CONTENTS',
        name: 'contents',
        width: 300,
        align: 'center',
        formatter(cell: any) {
          return `<div class="ellipsis"><span class="contentsView" data-request-id="${cell.row.requestId}" data-mt-pr="${cell.row.seq}">${escapeHtml(cell.value)}</span></div>`;
        },
      },
      {
        header: 'MANAGE_SMSSENDLIST_SEND_TYPE',
        name: 'messageType',
        align: 'center',
        minWidth: 85,
        formatter(cell: any) {
          if (cell.value) {
            return cell.value;
          } else {
            return window.$t('COMMON_ALL');
          }
        }
      },
      {
        header: 'MANAGE_SMSSENDLIST_DATE_TTL',
        name: 'requestDateTime',
        align: 'center',
        minWidth: 85
      }
    ],
    header: {
      height: 34
    },
    options: {
      rowHeight: 31,
      displayRowCount: 15,
      isInitialRequest: true,
      useClientSort: false,
      bodyHeight: 480,
      minBodyHeight: 480,
      columnOptions: {
        resizable: true
      },
      minRowHeight: 32,
      pageOptions: {
        perPage: 100,
        page: 1,
        totalCount: 0,
        visiblePages: 5
      }
    }
  };
  private contentBottomOption = {
    haveConfigBtn: false,
    haveExcelDownBtn: false,
    pageSize: '100',
    pageSizes: [
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      },
      {
        value: '500',
        name: 'COMMON_PAGE_SIZE_500'
      },
      {
        value: '1000',
        name: 'COMMON_PAGE_SIZE_1000'
      }
    ]
  };
  // lifecycle
  private created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
  }
  private beforeMount(){
    let noData = this.$t('MANAGE_SMSSENDLIST_NO_DATA') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
  private async mounted() {
    await this.fetchMalls();
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.attachEvent();

  }
  private beforeDestroy() {
    $('body').off('click', '.contentsView');
    $('body').off('click', '.requestDetail');
  }
  private destroyed(){
    let noData = this.$t('COMMON_RESULT_NONE') as string;
    TuiGrid.setLanguage('ko', {
      display: {
        noData
      }
    });
  }
  @Watch('$route.query.mallNo', {immediate: false, deep: false})
  async onMallChanged() {
    if (this.$route.query.mallNo) {
      this.mallNo = Number(this.$route.query.mallNo);
    } else {
      this.mallNo = this.malls[0].mallNo;
    }
    this.toFirstPage();
  }
  private attachEvent() {
    const $content = $('.content');
    $content.on('click', '.contentsView', $.proxy(this.onClickContentsView, this));
    $content.on('click', '.requestDetail', $.proxy(this.onClickRequestDetail, this));
  }
  private toFirstPage() {
    const url = `/sms/send-list?mallNo=${this.mallNo}&tabNo=1`;
    window.location.assign(url);
  }
  private reset() {
    this.endDate = getToday();
    let tempVue: any = this.$refs.datePicker;
    tempVue.clickPeriod('1w');
    this.getSmsMessagesRequest.params.messageType = 'SMS';
  }
  private async search(page: number) {
      this.getSmsMessagesRequest.params.page = page;
      this.getSmsMessagesRequest.params.pageSize = this.pageSize;
      this.getSmsMessagesRequest.params.startDate = this.startDate;
      this.getSmsMessagesRequest.params.endDate = this.endDate;
      const getSmsMessagesResponse = await this.$api.getSmsMessages(this.getSmsMessagesRequest);
      const {data} = getSmsMessagesResponse;
      this.setData(data.contents, data.totalCount, page, this.pageSize);
    document.getElementById('search_btn').blur()
  }
  private setData(messagesList: SmsMessages[], totalCount: number, page: number, pageSize: number) {
    this.messages = messagesList;
    this.totalCount = totalCount;
    this.gridProps.options.pageOptions.page = page;
    this.gridProps.options.pageOptions.perPage = pageSize;
    this.gridProps.options.pageOptions.totalCount = totalCount;
  }
  private onPageSizeChange(page: number, pageSize: number) {
    this.page = page;
    if (pageSize) {
      this.pageSize = pageSize;
    }
    this.search(page);
  }
  private onClickContentsView(e: any) {
    this.isClickView = true;
    $('body').addClass('no-scroll');
    const requestId = $(e.target).data('request-id');
    this.messages.forEach((e) => {
      if (e.requestId === requestId) {
        this.contentDetail = e.contents;
      }
    });
  }
  private onClickRequestDetail(e: any) {
    const $target = $(e.target);
    let requestId = $target.data('request-id');
    let smsType = $target.data('sms-type');
    let sendType = $target.data('send-type');
    let seq = $target.data('mt-pr');

    ncpPopup(
      `/sms/popup/recipient-list?mallNo=${this.$route.query.mallNo}&requestId=${requestId}&smsType=${smsType}&sendType=${sendType}&mtPr=${seq}`,
      `${window.$t('MANAGE_SMSSENDLIST_RECIPIENT_TTL')}`,
      1000,
      950
    );
  }
  private closeLayer() {
    this.isClickView = false;
    $('body').removeClass('no-scroll');
  }
}
